import { defineDirective } from "../../utils/angular"
import { transformLocationApiResult } from "../location"
import { IMapContainer, MapLocationsApiResult } from "../types"

/** @internal */
export class LocationCtrl {

    static create(): ng.IDirective {
        return defineDirective(LocationCtrl, "shared/map/location/location.html", {
            map: "=",
            isSearchExpanded: "=",
            extent: "="
        })
    }

    public map: IMapContainer
    public isSearchExpanded: boolean
    private searchText: string
    private results: MapLocationsApiResult[]

    public extent: number[]

    constructor() {
    }


    getLocations(query: string) {

        this.results = []

        return this.map.queryLocationApi(query).then(r => this.results = r)

    }

    selectLocation(value: MapLocationsApiResult, close: boolean = false): void {

        this.extent = transformLocationApiResult(value)

        if (this.extent && close) {
            this.isSearchExpanded = false
            this.searchText = ""
            this.results = []
        }

    }

}
